export const actionTypes = {
  USER_LOGIN: "USER_LOGIN",
  USER_LOGIN_RESPONSE: "USER_LOGIN_RESPONSE",
  USER_LOGOUT: "USER_LOGOUT",
  USER_LOGOUT_RESPONSE: "USER_LOGOUT_RESPONSE",
  USER_AUTH: "USER_AUTH",
  CLICK_MENU:'CLICK_MENU',
  SET_LOGIN_TOKEN: 'SET_LOGIN_TOKEN',
  SET_MESSAGE: "SET_MESSAGE",
  SET_VCODE: "SET_VCODE",
  SET_USER_AUDIT_NOTICE_TAG: "SET_USER_AUDIT_NOTICE_TAG",
  LOGOUT: "LOGOUT",
  SET_MANAGER_ACCOUNT: "SET_MANAGER_ACCOUNT",
  SET_COMPANY_INFO: "SET_COMPANY_INFO",
  SET_USER_INFO: "SET_USER_INFO",
  SET_ALL_PRODUCT_MANAGER: "SET_ALL_PRODUCT_MANAGER",
  SET_ALL_PRODUCT_MANAGER_FORMAT: "SET_ALL_PRODUCT_MANAGER_FORMAT",
};